var React = require('react');

function IcPlayWhiteOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5 20a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0-1.385a7.615 7.615 0 1 1 0-15.23 7.615 7.615 0 0 1 0 15.23Zm-.83-10.32a1 1 0 0 0-1.478.878v3.654a1 1 0 0 0 1.477.879l3.366-1.827a1 1 0 0 0 0-1.758L10.67 8.294Z","fill":"currentColor"}));
}

IcPlayWhiteOutline.defaultProps = {"viewBox":"0 0 23 22"};

module.exports = IcPlayWhiteOutline;

IcPlayWhiteOutline.default = IcPlayWhiteOutline;
